var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Paginate paginate-warp w-full py-4"},[_c('sliding-pagination',{attrs:{"current":_vm.pagination.currentPage,"total":_vm.pagination.length,"slidingWindowSize":7,"slidingEndingSize":3,"aria-goto-page-label":'跳转到第 {page} 页'},on:{"page-change":_vm.pageChangeHandler}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }